module.exports = {
  siteTitle: 'Andrew Liu | Software Engineer',
  siteDescription:
    'Andrew Liu is a software engineer and product designer based in Toronto, who specializes in developing and designing software projects',
  siteKeywords:
    'Andrew Liu, Andrew, Liu, andrewliu96, software engineer, front-end engineer, product designer, python, javascript, queens university',
  siteUrl: 'https://andrewl.co',
  siteLanguage: 'en_US',
  googleAnalyticsID: '',
  googleVerification: '',
  name: 'Andrew Liu',
  location: 'Toronto, Ontario',
  email: 'andrew.liu@queensu.ca',
  github: 'https://github.com/andrewliu96',
  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/andrewliu96',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/andrew-liu-336a2794/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '#about',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },
    {
      name: 'Work',
      url: '#projects',
    },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  navHeight: 100,
  greenColor: '#00bd90',
  navyColor: '#ffffff',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
